(function () {
   console.log('NPB swatches JS loaded');

  /* ------------------------------------------------------------
     Helpers
  ------------------------------------------------------------ */

  function findCard(el) {
    return el.closest('product-card') || el.closest('.product-card');
  }

  // ONLY pick an image from the main media area
  function findMainImage(card) {
    const selectors = [
      '.product-card__figure picture img',
      '.product-card__figure img',
      '.product-card__media picture img',
      '.product-card__media img',
      '.product-card__image-wrapper picture img',
      '.product-card__image-wrapper img'
    ];

    for (const sel of selectors) {
      const img = card.querySelector(sel);
      if (img) return img;
    }

    // Final fallback: first product image link
    const productLink = card.querySelector('a[href*="/products/"]');
    if (!productLink) return null;

    const imgs = Array.from(productLink.querySelectorAll('img')).filter(img =>
      !img.closest('.npb-product-card-swatches') &&
      !img.closest('.jdgm-prev-badge, .spr-badge, .yotpo, .stamped-badge')
    );

    return imgs[0] || null;
  }

  function setLabel(card, swatch) {
    const label = card.querySelector('.npb-swatch-label');
    if (!label || !swatch) return;
    label.textContent = swatch.getAttribute('data-swatch-label') || '';
  }

  function setActive(card, swatch) {
    if (!card || !swatch) return;
    card.querySelectorAll('.npb-product-card-swatch')
      .forEach(s => s.classList.remove('is-active'));
    swatch.classList.add('is-active');
    setLabel(card, swatch);
  }

  function swapImage(img, newSrc) {
    if (!img || !newSrc) return;

    img.src = newSrc;
    img.removeAttribute('srcset');

    img.setAttribute('data-src', newSrc);
    img.setAttribute('data-original-src', newSrc);

    const picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source')
        .forEach(s => s.removeAttribute('srcset'));
    }
  }

  /* ------------------------------------------------------------
     CLICK ONLY — no page-load mutation
  ------------------------------------------------------------ */

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.npb-product-card-swatch');
  if (!swatch) return;

  // prevent double-handling if script is loaded twice
  if (swatch.dataset.npbHandled === '1') return;
  swatch.dataset.npbHandled = '1';
  setTimeout(() => { delete swatch.dataset.npbHandled; }, 0);

  // Kill navigation + Impact instant handlers
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const card = swatch.closest('product-card') || swatch.closest('.product-card');
  if (!card) return;

  setActive(card, swatch);

  const img = findMainImage(card);
  const newSrc = swatch.getAttribute('data-swatch-image');
  swapImage(img, newSrc);
}, true);


})();
